import { render, staticRenderFns } from "./bookingNotification.vue?vue&type=template&id=bf02efe8"
import script from "./bookingNotification.vue?vue&type=script&lang=js"
export * from "./bookingNotification.vue?vue&type=script&lang=js"
import style0 from "./bookingNotification.vue?vue&type=style&index=0&id=bf02efe8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports